import React from 'react'

const CheckArrow = ({ ...props }) => {
  return (
    <svg
      width="105"
      height="105"
      viewBox="0 0 105 105"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M52.9338 96.2269C76.7977 96.2269 96.3227 76.7019 96.3227 52.838C96.3227 28.9741 76.7977 9.4491 52.9338 9.4491C29.0699 9.4491 9.54492 28.9741 9.54492 52.838C9.54492 76.7019 29.0699 96.2269 52.9338 96.2269Z"
        stroke="#979797"
        stroke-width="6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M34.4941 52.8381L46.7732 65.1172L71.3747 40.5591"
        stroke="#979797"
        stroke-width="6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export default CheckArrow
